// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryHeader_container__1afLu","subtitleContainer":"CategoryHeader_subtitleContainer__2FvYH","arrow":"CategoryHeader_arrow__1MF81"};